<template>
	<div>
		<v-dialog v-model="dialog_confimation" persistent no-click-animation transition="slide-y-transition" max-width="290">
	      <v-card>
	      	<v-card-title class="title noshadow" :class="[textClass ? textClass : '']">
	      		<v-icon v-if="icon" :class="[iconClass ? iconClass : '']">{{icon}}</v-icon>
	      		<span :class="[icon ? 'ml-3' : '']">{{header}}</span>
	      	</v-card-title>
	        <v-card-text class="pt-0" :class="[textClass ? textClass : '']" v-html="confirmationMessage"></v-card-text>
			<img src="../..\/assets/google_permission.png" width="100%" class="mb-3 pa-2" alt="" v-if="header=='Allow Google Permission'">
	        <v-divider v-if="!largeButtons"></v-divider>
	        <v-card-actions style="padding:6px 0px;">
	        	<v-layout row wrap v-if="!largeButtons">
	        		<v-flex xs6 sm6 md6 center-align style="border-right:1px #ddd solid">
	        			<v-btn small font-heavy capitalize dark-opacity-color flat @click="fn_closeDialog">{{cancelBtnText ? cancelBtnText : 'Close'}}</v-btn>
	        		</v-flex>
	        		<v-flex xs6 sm6 md6 center-align>
	        			<v-btn small font-heavy capitalize class="primary-color" flat @click="actionMethod(params)">{{okBtnText ? okBtnText : 'Ok'}}</v-btn>
	        		</v-flex>
	        	</v-layout>

				<v-layout row wrap pb-3 v-else>
					<v-flex xs12 sm12 md12 pr-3 pl-3 center-align>
	        			<v-btn block color="primary" @click="actionMethod(params)">{{okBtnText ? okBtnText : 'Ok'}}</v-btn>
	        		</v-flex>
	        		<v-flex xs12 sm12 md12 pr-3 pl-3 center-align mt-3 style="border-right:1px #ddd solid">
	        			<v-btn color="primary" block outline flat @click="fn_closeDialog">{{cancelBtnText ? cancelBtnText : 'Close'}}</v-btn>
	        		</v-flex>
	        	</v-layout>
		    </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>	 	

<script>

export default{
	props:['header', 'confirmationMessage', 'actionMethod', 'displayView', 'params', 'okBtnText', 'cancelBtnText', 'icon', 'iconClass', 'textClass', 'cancelMethod', 'largeButtons'],
	data(){	
		return{
			dialog_confimation: false,
		}
	},
	methods: {
		openDialogWeb: function () {	
			this.dialog_confimation = true;
		},
		closeDialogWeb: function () {
			this.dialog_confimation = false;
		},
		fn_closeDialog: function(){
			if(this.cancelMethod){
				this.cancelMethod();
				return;
			}

			if(this.displayView){
				this.closeDialogWeb();
			}
			else{
				this.$parent.fn_closeDialog();
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_confirmation.vue